import Isotope from "isotope-layout";
import Chocolat from "chocolat";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
gsap.registerPlugin(CustomEase, ScrollTrigger, MotionPathPlugin, MotionPathHelper);

if(document.body.classList.contains('page-template-page-cuisine')){

	window.addEventListener('load', function () {

		// FROG

		gsap.to("#cuisine-frog-animation__frog", {
      ease: "power1.inOut",
      duration:1.15,
      scrollTrigger: {
        trigger: "#cuisine-frog",
        start:"top 95%",
      },
      motionPath:{
        path: "#cuisine-frog-animation__path",
        align: "#cuisine-frog-animation__path",
        autoRotate: false,
        alignOrigin: [0.5, 0.5],
        start:1,
        end: 0
      }
    });

		// GALLERY

		Chocolat(document.querySelectorAll('.gallery-item a', {
			imageSize: 'cover'
		}))

		const filterButtons = document.querySelectorAll('.filter-gallery__filters button');
		let filters = {};

		// INIT

		const filterGallery = new Isotope( '.filter-gallery', {
		  layoutMode: 'masonry',
		  itemSelector: '.gallery-item',
		  percentPosition: true,
		  masonry: {
		    columnWidth: '.gallery-sizer',
		    gutter: '.gutter-sizer'
		  },
		});

		// UPDATE

		function concatValues( obj ) {
		  var value = '';
		  for ( var prop in obj ) {
		    value += obj[ prop ];
		  }
		  return value;
		}

		const handleButtonClick = (e) => {
			let button = e.target;
			let filterGroup = button.parentElement.parentElement.dataset.group;
			let allButtons = button.parentElement.parentElement.querySelectorAll('li button');

			// UPDATE BUTTON STATE

			allButtons.forEach((button) => {		
				button.classList.remove('active');	
			});
			
			button.classList.add('active');

			// UPDATE FILTERS

			filters[filterGroup] = button.dataset.filter;

			let filterValue = concatValues( filters );

			filterGallery.arrange({ filter: filterValue });

		}

		filterButtons.forEach((button) => {		
			button.addEventListener('click', handleButtonClick);
		});

	});

}